var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 48591",
    d: "M16 4.31544C13.225 4.04044 10.433 3.89844 7.65 3.89844C5.99685 3.8986 4.34475 3.98203 2.7 4.14844L1 4.31544",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 48592",
    d: "M5.57812 3.475L5.76113 2.383C5.89413 1.591 5.99412 1 7.40312 1H9.58613C10.9941 1 11.1031 1.625 11.2281 2.392L11.4111 3.475",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 48593",
    d: "M14.2148 6.94922L13.6728 15.3412C13.5808 16.6492 13.5058 17.6662 11.1808 17.6662H5.83078C3.50578 17.6662 3.43078 16.6492 3.33878 15.3412L2.80078 6.94922",
    stroke: "#8899B4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.46e57302e5564487684cb3da8f872a11.svg";
export { ForwardRef as ReactComponent };